import LocalStorageRepository from "../repository/LocalStorageRepository";
import {base, SUPPORTED_LANGS, withLang} from "../routes/LangLayout";

export function handleFatalError(message: string) {
    const stripped = window.location.pathname.slice(base.length);
    const pathSegments = stripped.split('/').filter(Boolean);
    const hasLangPrefix = pathSegments.length > 0 && SUPPORTED_LANGS.includes(pathSegments[0] as any);
    const storeId = (hasLangPrefix ? pathSegments[1] : pathSegments[0]) || null;

    if (storeId) {
        LocalStorageRepository.set('store_id', storeId);
    }

    LocalStorageRepository.set('fatal_error_message', message);
    window.location.href = withLang(`/fatal-error/${storeId}`);
}
